import React from "react";
import WiseContainer from "../../containers/Wise";

function Wise(props) {
  return <WiseContainer {...props} />;
}

export default Wise;
